import { useState } from 'react';
import Job from './Job';
import JobDetail from './JobDetail';
import { JOBS } from '../utils/constants';

export default function Experience () {
    const [activeJob, setActiveJob] = useState('0');

    function handleClick(id) {
        setActiveJob(id);
    }

    return (
        <div className="m-4 my-10 flex flex-col min-h-[400px]" id="experience">
            <h2 className='font-bold'>My Experience</h2>
            <div className='flex flex-col md:flex-row'>
                <div className="flex md:flex-col flex-grow flex-1">
                    {JOBS.map(jobInfo => <Job jobInfo={jobInfo} handleClick={handleClick} isActive={activeJob === jobInfo.id} key={jobInfo.id}/>)
                }
                </div>
                <div className="flex flex-col flex-grow flex-1 md:ml-4">
                    <JobDetail jobInfo={JOBS[activeJob]}/>
                </div>
            </div>

        </div>
    )
}